module.exports = __webpack_public_path__ + "static/img/story1.97feb19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/story1.jpg
// module id = FDrE
// module chunks = 0